import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

//@ts-ignore
import LKButton from 'shared/LKButton'
import { FORM_NAME } from './constants'

const valueSelector = formValueSelector(FORM_NAME)

const ChangeAccountIDs: FC<{
  change: (field: string, value: any) => void
  disabled: boolean
}> = ({ change }) => {
  const debitID = useSelector((state) => valueSelector(state, 'DebitAccID') || '')
  const debitHash = useSelector((state) => valueSelector(state, 'DebitAccHash') || '')
  const debit = useSelector((state) => valueSelector(state, 'DebitAccNo') || '')
  const debitTitle = useSelector((state) => valueSelector(state, 'DebitTitleUNI') || '')
  const debitBalance = useSelector((state) => valueSelector(state, 'DebitAccBalance') || 0)
  const debitChosenAccNo = useSelector((state) => valueSelector(state, 'DebitChosenAccNo') || '')
  const creditID = useSelector((state) => valueSelector(state, 'CreditAccID') || '')
  const creditHash = useSelector((state) => valueSelector(state, 'CreditAccHash') || '')
  const credit = useSelector((state) => valueSelector(state, 'CreditAccNo') || '')
  const creditTitle = useSelector((state) => valueSelector(state, 'CreditTitleUNI') || '')
  const creditBalance = useSelector((state) => valueSelector(state, 'CreditAccBalance') || 0)
  const creditChosenAccNo = useSelector((state) => valueSelector(state, 'CreditChosenAccNo') || '')

  function handleClick() {
    change('DebitAccNo', credit)
    change('DebitTitleUNI', creditTitle)
    change('DebitAccID', creditID)
    change('DebitAccHash', creditHash)
    change('DebitAccBalance', creditBalance)
    change('DebitChosenAccNo', creditChosenAccNo)

    change('CreditAccNo', debit)
    change('CreditTitleUNI', debitTitle)
    change('CreditAccID', debitID)
    change('CreditAccHash', debitHash)
    change('CreditAccBalance', debitBalance)
    change('CreditChosenAccNo', debitChosenAccNo)
  }

  return <LKButton onClick={handleClick} alias="reverse" />
}

export default ChangeAccountIDs
